import { render, staticRenderFns } from "./StrategyProjectCreate.vue?vue&type=template&id=89df0a5c&scoped=true"
import script from "./StrategyProjectCreate.vue?vue&type=script&lang=js"
export * from "./StrategyProjectCreate.vue?vue&type=script&lang=js"
import style0 from "./StrategyProjectCreate.vue?vue&type=style&index=0&id=89df0a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89df0a5c",
  null
  
)

export default component.exports